export enum BaseMapFilterEnum {
    RADIO = 'radio',
    CHIP = 'chip',
    MULTISELECT = 'multiselect',
    DATE_RANGE = 'date_range',
    NUMBER_RANGE = 'number_range',
    CHECKBOX = 'checkbox'
}

export interface IBaseMapFilterOption {
    value: string,
    bg_color?: string,
    text_color?: string
}

export interface IBaseMapFilter {
    id: number,
    layer_id: number,
    name: string,
    disabled: boolean,
    type: BaseMapFilterEnum,
    placement: string,
    radio_group?: number | null,
    options?: Array<IBaseMapFilterOption>
    min_value?: number,
    max_value?: number
}

export interface IMapData {
    displayName: string
    names?: Array<IName>
    processes: Array<string>
    geocoded_address: IGeocodedMapData
    address: IAddress
    geojson?: number[][][]
    country_name?: string
    current_count?: number
    center?: [number, number]
}

export interface IMapLayerData extends IMapLayer {
    data: Array<IMapData>
}

export interface ICoordinates {
    lat: number,
    lon: number
}

export interface IName {
    name: string,
    spacecow_tags?: Array<string>
}

export interface IGeocodedMapData {
    location: ICoordinates
    address: IAddress
}

export interface IAddress {
    line_1: string,
    line_2: string,
    city: string,
    state?: string,
    country: string,
    zip?: string,
    zip_4?: string,
    congressional_district?: string,
    county: string,
}

export enum MapLayerTypes {
    Point = "point",
    Cluster = "cluster",
    Choropleth = "choropleth"
}

export interface IClusterConfig {
    color: string,
    point_count: string | null
}

export interface ILayerDetailsDataFilter {
    field: string
    method: string
    value: any
}

export interface IEnumConfig {
    value: string | boolean,
    bg_color: string,
    text_color: string
}

export interface ILayerDetailsData {
    label?: string,
    key: string
    display?: string,
    filter?: ILayerDetailsDataFilter
    type?: string,
    prefix?: string,
    suffix?: string,
    tooltip?: string,
    fields?: Array<string>,
    anchor_text?: string,
    enum_configs?: Array<IEnumConfig>,
    allowed_keys?: Array<string>
}

export interface IMapLayerDetails {
    type: string,
    key?: string,
    label?: string,
    data?: Array<ILayerDetailsData>
    display?: string,
    filter?: ILayerDetailsDataFilter,
    enum_configs?: Array<IEnumConfig>,
}

export interface ILayerMapConfigs {
    type: MapLayerTypes,
    icon_image?: string,
    cluster_configs?: Array<IClusterConfig>
    point_color?: string
    count_text?: string
    jiggle_overlap?: boolean
}

export interface ILayerDetailViewConfigs {
    details?: Array<IMapLayerDetails>
}

export interface IBaseMapLayer {
    id: number,
    name: string,
    filters: Array<IBaseMapFilter>,
    index: string,
    map_configs: ILayerMapConfigs,
    detailed_view_configs?: ILayerDetailViewConfigs
}

export interface IMapLayer extends IBaseMapLayer {
    visible: boolean
}


export interface IActiveFilter {
    id: number,
    value: string | boolean
}